import styled from '@emotion/styled'
import { Button } from '@design-systems/canvas-ui'

export const ChatBotContainer = styled.div`
  width: ${(props) => (props.expand ? '690px' : '375px')};
  height: 600px;
  text-align: left;
`

export const StyledHeader = styled.div`
  display: flex;
  background-color: var(--canvas-theme-color--background);
  justify-content: space-between;
  color: var(--canvas-theme-color--text);
`

export const StyledButton = styled(Button)`
  color: var(--canvas-theme-color--text);
`
export const LostConnectionPopup = styled.div`
  width: ${(props) => (props.expand ? '690px' : '375px')};
  height: 251px;
  position: fixed;
  bottom: 0px;
  padding: 24px 0px 24px 0px;
  gap: 24px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
  background: var(--canvas-theme-color--text);
  box-shadow: 0px -5px 8px -4px var(--canvas-border-color--default-active);
  box-shadow: 0px -12px 20px -4px var(--canvas-border-color--default-active);
  z-index: 999;
`
export const BoldText = styled.div`
  font-weight: bold;
`

export const StyledOptions = styled.div`
  display: ${(props) => (props.isInlineBlock ? 'inline-block' : 'block')};
  .C-Button {
    background-color: ${(props) =>
      props.isNavigationButton
        ? 'var(--canvas-background-color--placeholder)'
        : 'var(--canvas-background-color--default)'};
    color: var(--canvas-theme-color--background);
    border: 1px solid var(--canvas-border-color--default-hover);
    text-align: left;
    padding: 7px;
    height: auto;
  }

  .C-Button:hover {
    background-color: ${(props) =>
      props.isNavigationButton ? '#d5d2d2' : '#e7e9ea'};
    color: var(--canvas-theme-color--background);
    border: 1px solid #d3d5d8;
  }
`
export const CenterAlign = styled.div`
  justify-content: center;
`
export const StyledChatBotWindow = styled.div`
  overflow: ${(props) => (props.diableScroll ? 'hidden' : 'auto')};
  filter: ${(props) => (props.diableScroll ? 'blur(3px)' : 'unset')};
`
export const StyledToastMessage = styled.div`
  margin: auto;
  padding: 15px;
  width: 75%;
  font-size: 16px;
  border-radius: 10px;
  background: var(--canvas-background-color--placeholder);
  margin-top: 16px;
  margin-left: 50px;
  margin-bottom: 20px;
`
